import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { fmtDateTime, fmtTL } from "@/lib/format";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { toast } from "sonner";
import { RotateCcw, Trash2 } from "lucide-react";

export const TrashBin = () => {
  const [items, setItems] = useState([]);
  const load = () => api.get("/trash").then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const restore = async (t) => {
    try { await api.post(`/trash/${t.id}/restore`); toast.success(`${t.type_label} geri getirildi: ${t.label}`); load(); }
    catch (e) { toast.error(typeof e.response?.data?.detail === "string" ? e.response.data.detail : "Geri getirilemedi"); }
  };
  const purge = async (t) => {
    if (!window.confirm(`"${t.label}" kalıcı olarak silinecek ve geri getirilemeyecek. Emin misiniz?`)) return;
    await api.delete(`/trash/${t.id}`); toast.success("Kalıcı olarak silindi"); load();
  };

  return (
    <Card className="p-5" data-testid="trash-bin">
      <h3 className="font-bold text-lg mb-1">Çöp Kutusu / Silinen Kayıtlar</h3>
      <p className="text-xs text-muted-foreground mb-4">Silinen kayıtlar fiziksel olarak silinmez, burada saklanır. Geri getirildiğinde cari bakiye, stok ve hesap bakiyeleri otomatik yeniden hesaplanır.</p>
      <Table>
        <TableHeader><TableRow><TableHead>Silinme</TableHead><TableHead>Tür</TableHead><TableHead>Kayıt</TableHead><TableHead className="text-right">Tutar</TableHead><TableHead>Silen</TableHead><TableHead></TableHead></TableRow></TableHeader>
        <TableBody>
          {items.map((t) => (
            <TableRow key={t.id} data-testid={`trash-row-${t.id}`}>
              <TableCell className="num text-sm">{fmtDateTime(t.deleted_at)}</TableCell>
              <TableCell><span className="text-xs px-2 py-0.5 rounded bg-muted">{t.type_label}</span></TableCell>
              <TableCell className="font-semibold">{t.label}</TableCell>
              <TableCell className="text-right num">{t.amount != null ? fmtTL(t.amount) : "-"}</TableCell>
              <TableCell className="text-sm">{t.deleted_by}</TableCell>
              <TableCell className="text-right">
                <Button variant="ghost" size="sm" className="text-emerald-500" onClick={() => restore(t)} data-testid={`trash-restore-${t.id}`}><RotateCcw size={14} className="mr-1" /> Geri Getir</Button>
                <Button variant="ghost" size="icon" title="Kalıcı sil" onClick={() => purge(t)} data-testid={`trash-purge-${t.id}`}><Trash2 size={14} /></Button>
              </TableCell>
            </TableRow>
          ))}
          {items.length === 0 && <TableRow><TableCell colSpan={6} className="text-center py-8 text-muted-foreground">Çöp kutusu boş</TableCell></TableRow>}
        </TableBody>
      </Table>
    </Card>
  );
};
